import * as React from "react";
const SvgCaretBottom = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M11.5 5 8 8.5 4.5 5 3 6.5l5 5 5-5z" }));
export default SvgCaretBottom;
